import { WaybillIdView } from '../../../../models';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadAllFacade, MeasurementUnitCodesEnum, SetInitialStateFacade } from '../../../../../common';
import { ShipmentWaybillEquipmentsState } from './shipment-waybill-equipments.state';
import { Observable } from 'rxjs';
import {
  ShipmentWaybillEquipmentsInitialState,
  ShipmentWaybillEquipmentsLoad,
} from './shipment-waybill-equipments.actions';
import { WaybillEquipmentItemModel } from '../../../../models/waybill-equipments.model';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillEquipmentsFacade implements LoadAllFacade, SetInitialStateFacade {
  equipments$: Observable<WaybillEquipmentItemModel[]> = this.store.select(
    ShipmentWaybillEquipmentsState.getEquipments,
  );
  weightUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentWaybillEquipmentsState.getWeightUnitCode,
  );
  volumeUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentWaybillEquipmentsState.getVolumeUnitCode,
  );
  dimensionsUnitCode: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentWaybillEquipmentsState.getDimensionsUnitCode,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillEquipmentsState.getLoaded);

  constructor(private store: Store) {}

  loadAll(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillEquipmentsLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillEquipmentsInitialState());
  }
}
